import { Injectable } from "@angular/core";
import { COMPLAIN_STATUS_CONSTANT } from "../constant/complainChart.constant";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ComplainStatusService {
  constructor(private httpClient: HttpClient) {}

  //chart complain status
  getComplainStatusChartData() {
    return this.httpClient.get(
      `${COMPLAIN_STATUS_CONSTANT.COMPLAIN_STATUS_COUNT}`
    );
  }
}
